import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=bfc03ccc&"
import script from "./DesktopMenu.vue?vue&type=script&lang=ts&"
export * from "./DesktopMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports